import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_pet: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_pet) {
        info.user_pet.filter((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }
    },
    addData: (state, info) => {
      info.user_pet.editableFlag = true
      state.data.user_pet.push(info.user_pet)
    },
    updateData: (state, info) => {
      return state.data.user_pet = state.data.user_pet.filter((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_pet = state.data.user_pet.filter((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit}) {
      const response = await axios.get('user/data/pet')
      commit ('fetchData', response.data)
    },
    async updateData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('user/data/pet/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit}, data) {
      data.birth_date = $day(data.birth_date).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.post('user/data/pet', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('user/data/pet/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
